export async function enableMocking(): Promise<void> {
  if (import.meta.env.VITE_ENABLE_API_MOCKS !== 'true') {
    await unregisterMockServiceWorker()
    return
  }

  const { worker } = await import('./browser')
  await worker.start({ onUnhandledRequest: 'bypass' })
}

async function unregisterMockServiceWorker(): Promise<void> {
  if (!('serviceWorker' in navigator)) {
    return
  }

  const registrations = await navigator.serviceWorker.getRegistrations()
  await Promise.all(
    registrations
      .filter((registration) => registration.active?.scriptURL.includes('mockServiceWorker.js'))
      .map((registration) => registration.unregister()),
  )
}
